import {TimeoutHandle} from 'notability-services-common-universal'
import {useEffect, useRef, useState} from 'react'

export function useThrottledValue<T>(value: T, wait: number) {
  const [throttledValue, setThrottledValue] = useState<T>(value)
  const lastExecuted = useRef(Date.now())
  const timeoutRef = useRef<TimeoutHandle | undefined>(undefined)

  useEffect(() => {
    const now = Date.now()

    timeoutRef.current = setTimeout(
      () => {
        setThrottledValue(value)
        lastExecuted.current = Date.now()
      },
      wait - (now - lastExecuted.current)
    )

    return () => {
      clearTimeout(timeoutRef.current)
    }
  }, [value, wait])

  return throttledValue
}
